import type { LucideIcon } from "lucide-react";
import { useState } from "react";
import { fileUrl } from "@/lib/upload";
import { cn } from "@/lib/utils";

/** Thumbnail of an uploaded image, or an icon tile when there is none. */
export function FileImage({
  fileId,
  alt,
  icon: Icon,
  className,
  full = false,
}: {
  fileId: string | null | undefined;
  alt: string;
  icon: LucideIcon;
  className?: string;
  full?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  return (
    <div
      className={cn(
        "relative flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-muted",
        className,
      )}
    >
      {fileId && !failed ? (
        <img
          src={fileUrl(fileId, { thumb: !full })}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
          className="size-full object-cover"
        />
      ) : (
        <Icon className="size-[45%] max-h-8 max-w-8 text-muted-foreground/60" strokeWidth={1.5} />
      )}
    </div>
  );
}
